import { useEffect, useState } from "react";
import { ChevronRight,ChevronDown  } from "lucide-react";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
// import {UserIc} from "@heroicons/react"
// Register Chart.js components
import { FaUser } from "react-icons/fa";

import { nanoid } from "nanoid";
import { LuMousePointerClick } from "react-icons/lu";
import { GiSandsOfTime } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import { PiScrollBold } from "react-icons/pi";
import { BsCartPlusFill } from "react-icons/bs";

import { UserIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectScreenshortURLs,
  SelectSiteUsersDBData,
  setCurrentHeatMapDetail,
  updatePropertyVal,
  setCurrentSelectedPage,
} from "../../HeatmapXUserSegmentSlice";
import { useNavigate } from "react-router-dom";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { LoadingHeatMapInsight } from "../HeatmapResult/DetailedHeatmapTable/TabularInsights";
import { getDataFromMongoDb } from "../../../../services/mongod.data";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);


export default function FunnelView({ data, currentWeek }) {
  const [selectedPath, setSelectedPath] = useState([]);
  const [expandedNodes, setExpandedNodes] = useState({});
  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    if (data) {
      setSelectedPath([data]); // Ensure root data is set
      setTabs([{ node: data, level: 0 }]);
    }
  }, [data]);

  const toggleNode = (node) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [node.name]: !prev[node.name],
    }));
  };

  const handleNodeSelect = (node, level) => {
    if (!node) return;
    
    // Find the exact path from root to selected node
    const findPath = (currentNode, targetNode, path = []) => {
      if (!currentNode) return null;
      const newPath = [...path, currentNode];
      if (currentNode === targetNode) return newPath;
      for (let child of currentNode.children || []) {
        const result = findPath(child, targetNode, newPath);
        if (result) return result;
      }
      return null;
    };

    const newPath = findPath(data, node);
    if (newPath) {
      setSelectedPath(newPath);
      setExpandedNodes({}); // Close all dropdowns when selecting a child
      setTabs(newPath.map((n, index) => ({ node: n, level: index })));
    }
  };

  const renderTree = (node, level = 0) => {
    if (!node) return null;

    return (
      <div key={node.name} className="ml-4 border-l border-gray-300 pl-2">
        <div
          className={`flex items-center space-x-2 cursor-pointer hover:bg-gray-300 hover:text-gray-700 px-2 py-1.5 rounded-md ${
            selectedPath[selectedPath.length - 1]?.name === node.name
              ? "bg-blue-600 text-white hover:!bg-blue-600"
              : "text-gray-800"
          }`}
          onClick={() => handleNodeSelect(node, level)}
        >
          {node.children?.length > 0 && (
            <span onClick={(e) => { e.stopPropagation(); toggleNode(node); }}>
              {expandedNodes[node.name] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
            </span>
          )}
          <span className="flex items-center gap-1">{node.name}
            <span className="flex items-center gap-2">(<FaUser className="h-3.5 object-cover fill-current" /> {node.totalUsers})</span>
          </span>
        </div>
        {expandedNodes[node.name] && node.children?.length > 0 && (
          <div>{node.children.map((child) => renderTree(child, level + 1))}</div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 flex flex-col">
      {/* 📌 File Manager Navigation */}
      <div className="h-1/5 bg-white shadow-md px-6 py-4 overflow-y-auto flex">
        {tabs.map(({ node, level }) => (
          <div key={level} className="mr-4">
            {renderTree(node, level)}
          </div>
        ))}
      </div>

      {/* 📌 Analytics Panel */}
      <div className="h-4/5 p-6">
        {selectedPath.length > 0 && selectedPath[selectedPath.length - 1] ? (
          <AnalyticsPanel node={selectedPath[selectedPath.length - 1]} currentWeek={currentWeek} />
        ) : (
          <p>No data selected</p>
        )}
      </div>
    </div>
  );
}


/* 📌 Analytics Panel */
function AnalyticsPanel({ node, currentWeek }) {
  const [nextURLs, setNextURLs] = useState([]);
  const [heatmapData, setHeatmapData] = useState({});
  const [loading, setLoading] = useState(false);
  const [referrers, setReferrers] = useState([])

  const SiteUsersDBData = useSelector(SelectSiteUsersDBData);
  console.log("SiteUsersDBData", SiteUsersDBData);
  const AccountInfo = useSelector((state) => state.auth.accountInfo);

  useEffect(() => {
    if (SiteUsersDBData) {
      let insgihtResult = GetHeatmapURLInsight(
        SiteUsersDBData[0] ?? {}
      );
      setHeatmapData(insgihtResult);
      console.log("SiteUsersDBData[currentWeek]", SiteUsersDBData[0]);
    }
  }, [SiteUsersDBData]);


  useEffect(() => {
    if (node?.children) {
      const sortedTopFive = [...node.children]
        .sort((a, b) => b.value - a.value) // Sort in descending order
        .slice(0, 5); // Pick top 5

      console.log("Top 5 items:");
      sortedTopFive.forEach((item) => {
        console.log(item.value, item.name);
      });
      setNextURLs(sortedTopFive);
    }

    if (node?.referrers) {
      setReferrers(node.referrers)
    }
  }, [node]);

  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const screenshortURLs = useSelector(SelectScreenshortURLs);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const normalizeUrl = (url) => {
    return url.split('#')[0]; // removes everything after and including '#'
  };

  const ViewHeatmapClickHandler = async (url) => {
    const normalizedUrl = normalizeUrl(url);

    let data = SiteUsersDBData[currentWeek][normalizedUrl];

    const heatmapId = nanoid();

    let screenshotURL = await fetchScreenshotURL(normalizedUrl, heatmapId);
    if (!screenshotURL) {
      console.log("issue with screenshotURL", screenshotURL);
      return;
    }

    dispatch(
      setCurrentHeatMapDetail({
        targetRoute: normalizedUrl,
        heatmapId,
        data: data,
        screenshotURL,
        weekLabel: currentWeek,
      })
    );
    dispatch(setCurrentSelectedPage("explore"));
    navigate(`/heatmap/view/${heatmapId}`);
  };

  // const fetchScreenshotURL = async (url, heatmapId) => {
  //   // console.log("screenshortURLs", screenshortURLs)
  //   setLoading(true);
  //   const matchedData = screenshortURLs?.find(
  //     (heatmapItem) => heatmapItem.originalURL === url
  //   );
  //   if (matchedData) return matchedData;

  //   try {
  //     const postData = { website: url, urlId: heatmapId, dbProd: user };
  //     const api_link = "https://www.api.causalfunnels.com/screenshot";
  //     // const api_link = "https://causalfunnel.org:8080/screenshot";

  //     const response = await fetch(api_link, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(postData),
  //     });

  //     if (!response.ok) {
  //       throw new Error(
  //         `Failed to fetch new image URL: ${response.statusText}`
  //       );
  //     }

  //     const responseData = await response.json();

  //     dispatch(
  //       updatePropertyVal({
  //         key: "screenshortURLs",
  //         val: [...(screenshortURLs || []), responseData.screenshots],
  //       })
  //     );

  //     console.log("Heatmap URLs ->", responseData.screenshots);

  //     return responseData.screenshots;
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     return null; // Return null on failure
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchScreenshotURL = async (url, heatmapId, update = "false") => {
    setLoading(true);
    if (update === "false") {
      const matchedData = screenshortURLs.find((heatmapItem) => heatmapItem.originalURL === url);
      if (matchedData) {
        setLoading(false);
        return matchedData;
      } else {
        console.log("No matching URL found, fetching new screenshot.");
      }
    }

    try {
      const postData = { website: url, urlId: heatmapId, dbProd: user };
      const api_link = "https://www.api.causalfunnels.com/screenshot";
      const response = await fetch(api_link, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(postData),
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch new image URL: ${response.statusText}`);
      }
      const responseData = await response.json();
      dispatch(updatePropertyVal({ key: "screenshortURLs", val: [...(screenshortURLs || []), responseData.screenshots] }));
      return responseData.screenshots;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const GetHeatmapURLInsight = (data) => {
    let insightResult = {};
    console.log("data", data);

    Object.entries(data).forEach(([url, urlData]) => {
      let result = {
        clicks: 0,
        moves: 0,
        scrollDepth: 0,
        scrollPerc: {},
      };

      let { blocks, scrollDepth_perc } = urlData;

      if (scrollDepth_perc === undefined) {
        result["scrollDepth"] = 0;
      } else {
        let maxScrollFromPerc = 0;
        Object.entries(scrollDepth_perc).forEach(([range, count]) => {
          if (count > 0) {
            const parts = range.split("_");
            const upperBound = parseInt(parts[1], 10);
            maxScrollFromPerc = Math.max(maxScrollFromPerc, upperBound);
          }
        });
        result["scrollDepth"] = maxScrollFromPerc;
        result["scrollPerc"] = { ...scrollDepth_perc } || {};
      }

      if (blocks) {
        Object.entries(blocks).forEach(([xy, blockData]) => {
          Object.entries(blockData).forEach(([userType, userTypeData]) => {
            Object.entries(userTypeData).forEach(
              ([userTraffic, userTrafficData]) => {
                Object.entries(userTrafficData).forEach(
                  ([userDevice, userData]) => {
                    let { clicks, moves } = userData;
                    result.clicks += clicks || 0;
                    result.moves += moves || 0;
                  }
                );
              }
            );
          });
        });
      }
      insightResult[url] = result;
    });

    return insightResult;
  };

  return (
    <div className="w-full bg-white shadow-lg rounded-lg p-6 border border-gray-300 flex flex-col">
      {loading && <LoadingHeatMapInsight setLoading={setLoading} />}

      <h3 className="text-lg font-semibold mb-4 text-gray-800">
        📊 Analytics for
        <a
          className="underline ml-1 hover:text-blue-600"
          href={node.URL}
          rel="noopener noreferrer"
          target="_blank"
        >
          {node.name}
        </a>
      </h3>

      <div className="flex">
        {/* 📌 Page Stats + Heatmap Button */}
        <div className="w-1/2 pr-4 border-r border-gray-300">
          <div className="bg-gray-100 p-4 rounded-lg shadow-md">
            <h3 className="text-md font-semibold text-gray-800 border-b pb-2 mb-4">
              📌 Page Insights
            </h3>
            <div className="text-sm text-gray-700 space-y-3">
              <StatItem icon={<FaRegUser/>} label="Users" value={node.totalUsers} />
              <StatItem icon={<LuMousePointerClick/>} label="Clicks"  value={node.clicks} />
              <StatItem icon={<GiSandsOfTime/>} label="Avg Time" value={node.avgTime} />
              <StatItem icon={<PiScrollBold/>} label="Scroll %" value={node.scroll} />
              <StatItem icon={<BsCartPlusFill />} label={AccountInfo?.checkoutLabel ? `${AccountInfo.checkoutLabel} Clicks` : "Book Button Clicks" } value={node.bookBtnClicks ?? 0} />
            </div>
          </div>

          {/* 📌 HeatMap Button */}
          <button
            onClick={() => ViewHeatmapClickHandler(node.URL)}
            className="mt-6 w-full bg-gradient-to-r from-amber-500 to-orange-600 text-white font-semibold px-5 py-3 rounded-lg hover:shadow-lg transform hover:scale-[1.03] transition-all duration-200 ease-in-out"
          >
            🔥 View HeatMap Data
          </button>
        </div>

        {/* 📌 Next Visited & Users Came From */}
        <div className="w-1/2 pl-4">
          <SectionCard title="Next Visited URLs">
            {nextURLs?.map((item) => (
              <StatRow label={`/${item.name}`} value={`${item.value}`} link={item.URL} />
            ))}
          </SectionCard>

          <SectionCard title="Users Came From URLs" extraStyles="mt-4">
            {referrers &&
              referrers.filter(item => item[0].includes(user.split("-prod")[0])).length > 0 ? (
                referrers
                  .filter(item => item[0].includes(user.split("-prod")[0]))
                  .map(item => (
                    <StatRow
                      key={item[0]}
                      label={item[0]}
                      value={item[1]}
                      link={item[0]}
                    />
                  ))
              ) : (
                <p className="text-blue-500 text-sm mt-2">No data found</p>
              )}
          </SectionCard>
        </div>
      </div>

      {/* 📌 Traffic Insights (Pie Charts) */}
      <div className="my-6">
        <TrafficInsightsCharts data={node} />
      </div>

      {/* 📌 Additional Data Section */}
      <div className="flex mt-6">
        {/* 📌 Referrer Details */}
        <div className="w-1/2 pr-4">
        <SectionCard title="🌍 Referrer Sources">
          {referrers &&
            referrers.filter(item => !item[0].includes(user.split("-prod")[0])).length > 0 ? (
              referrers
                .filter(item => !item[0].includes(user.split("-prod")[0]))
                .map(item => (
                  <StatRow
                    key={item[0]}
                    label={item[0]}
                    value={item[1]}
                    link={item[0]}
                  />
                ))
            ) : (
              <p className="text-blue-500 text-sm mt-2">No data found</p>
            )}
        </SectionCard>
        </div>

        {/* 📌 UTM Params */}
        <div className="w-1/2 pl-4">
          <SectionCard title="🔗 UTM Tracking Parameters">
            <StatRow label="utm_source=google_ads" value="5" />
            <StatRow label="utm_campaign=xyz" value="2" />
          </SectionCard>
        </div>
      </div>
    </div>
  );
}

/* 📌 Traffic Insights - Pie Charts */

function TrafficInsightsCharts({ data }) {
  // console.log("data", data);

  // Extract values from incoming data
  const mobileUsers = data?.devices?.mobile || 0;
  const desktopUsers = data?.devices?.desktop || 0;

  const organicUsers = data?.userSources?.organic || 0;
  const paidUsers = data?.userSources?.paid || 0;

  const firstTimeUsers = data?.userTypes?.first_time || 0;
  const returningUsers = data?.userTypes?.returning || 0;

  const chartData = [
    {
      title: "📱 Mobile vs 💻 Desktop",
      data: [mobileUsers, desktopUsers],
      labels: ["Mobile Users", "Desktop Users"],
      colors: ["#FF6384", "#36A2EB"],
    },
    {
      title: "🌱 Organic vs 💰 Paid",
      data: [organicUsers, paidUsers],
      labels: ["Organic Users", "Paid Users"],
      colors: ["#4CAF50", "#FFCE56"],
    },
    {
      title: "🆕 First vs 🔁 Returning",
      data: [firstTimeUsers, returningUsers],
      labels: ["First-Time Users", "Returning Users"],
      colors: ["#9966FF", "#FFA500"],
    },
  ];

  return (
    <div className="w-full p-4 border border-gray-300 rounded-lg shadow-md bg-white">
      <h3 className="text-lg font-semibold text-gray-800 border-b pb-2 mb-4">
        📊 Session & Traffic Insights
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {chartData.map((item, index) => (
          <div key={index} className="bg-gray-50 p-4 rounded-lg shadow">
            <h4 className="text-md font-semibold text-gray-700 mb-2 text-center">
              {item.title}
            </h4>
            <Pie
              data={{
                labels: item.labels,
                datasets: [
                  {
                    data: item.data,
                    backgroundColor: item.colors,
                  },
                ],
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

/* 📌 Utility Components */
function StatItem({ label, value , icon}) {
  return (
    <div className="flex justify-between items-center">
      <span className="text-gray-700 flex gap-2 items-center">{icon} {label}:</span>
      <span className="text-gray-900 font-semibold">{value}</span>
    </div>
  );
}

function SectionCard({ title, children, extraStyles }) {
  return (
    <div
      className={`border border-gray-300 p-4 rounded-md shadow-sm ${extraStyles}`}
    >
      <h3 className="text-md font-semibold text-gray-700 border-b pb-2 mb-2">
        {title}
      </h3>
      <div className="space-y-2">{children}</div>
    </div>
  );
}

/* 📌 Stat Row (For Next Visited URLs, Users Came From, UTM Params) */
function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

function StatRow({ label, value, link }) {
  const isUrl = isValidUrl(label);

  return (
    <div className="flex justify-between items-center space-x-4 group relative">
      <span className="text-gray-600 truncate max-w-[70%] relative cursor-pointer">
        {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            {label}
          </a>
        ) : (
          label
        )}

        {/* Tooltip */}
        <span className="absolute left-0 bottom-full mb-1 w-max max-w-xs bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
          {label}
        </span>
      </span>

      <span className="text-gray-800 font-medium text-nowrap">→ {value}</span>
    </div>
  );
}
